import React from 'react';
import { Link } from 'react-router-dom';
import { ScanLine } from 'lucide-react';

const footerLinks = {
  Product: [
    { label: 'Features', to: '/#features' },
    { label: 'Pricing', to: '/#pricing' },
    { label: 'AI Scanning', to: '/#features' },
    { label: 'Tax Reports', to: '/#features' },
    { label: 'Mileage Tracker', to: '/#features' },
  ],
  Company: [
    { label: 'About Us', to: '/about' },
    { label: 'Blog', to: '/blog' },
    { label: 'Contact', to: '/contact' },
  ],
  Legal: [
    { label: 'Privacy Policy', to: '/privacy' },
    { label: 'Terms of Service', to: '/terms' },
    { label: 'Cookie Policy', to: '/cookie-policy' },
    { label: 'Security', to: '/security' },
  ],
};

export default function PublicPageLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      {/* Sticky Navbar */}
      <nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-lg border-b border-slate-200/60" data-testid="public-navbar">
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="bg-emerald-500 p-2 rounded-xl">
              <ScanLine className="w-5 h-5 text-white" />
            </div>
            <div>
              <span className="text-lg font-bold text-slate-900">ExpensIQ</span>
              <div className="text-[9px] font-medium text-slate-400 tracking-widest -mt-0.5">AUSTRALIA</div>
            </div>
          </Link>
          <div className="hidden md:flex items-center gap-6">
            <Link to="/about" className="text-sm text-slate-600 hover:text-slate-900 transition-colors">About</Link>
            <Link to="/blog" className="text-sm text-slate-600 hover:text-slate-900 transition-colors">Blog</Link>
            <Link to="/contact" className="text-sm text-slate-600 hover:text-slate-900 transition-colors">Contact</Link>
            <Link to="/login" className="text-sm font-semibold text-emerald-600 hover:text-emerald-700 transition-colors">Sign In</Link>
            <Link to="/register" className="px-4 py-2 bg-emerald-500 hover:bg-emerald-600 text-white text-sm font-semibold rounded-xl transition-colors">Get Started</Link>
          </div>
        </div>
      </nav>

      {/* Content */}
      <main className="flex-1">{children}</main>

      {/* Footer */}
      <footer className="bg-slate-900 text-slate-400 py-16" data-testid="public-footer">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
            <div className="col-span-2 md:col-span-1">
              <div className="flex items-center gap-2.5 mb-4">
                <div className="bg-emerald-500 p-2 rounded-xl"><ScanLine className="w-5 h-5 text-white" /></div>
                <div><span className="text-lg font-bold text-white">ExpensIQ</span><div className="text-[9px] font-medium text-slate-500 tracking-widest -mt-0.5">AUSTRALIA</div></div>
              </div>
              <p className="text-sm text-slate-500">Smart expense tracking built for Australian businesses and freelancers.</p>
            </div>
            {Object.entries(footerLinks).map(([title, links]) => (
              <div key={title}>
                <h4 className="text-sm font-semibold text-white mb-4">{title}</h4>
                <div className="space-y-2.5">
                  {links.map(l => (
                    <Link key={l.label} to={l.to} className="block text-sm text-slate-500 hover:text-slate-300 transition-colors">{l.label}</Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div className="border-t border-slate-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-slate-500">&copy; 2026 ExpensIQ Australia. All rights reserved.</p>
            <p className="text-sm text-slate-500">Made with care in Australia</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
